import { render } from "./Alcohol.vue?vue&type=template&id=e94eecd2&scoped=true"
import script from "./Alcohol.vue?vue&type=script&lang=js"
export * from "./Alcohol.vue?vue&type=script&lang=js"

import "./Alcohol.vue?vue&type=style&index=0&id=e94eecd2&lang=css"
import "./Alcohol.vue?vue&type=style&index=1&id=e94eecd2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e94eecd2"]])

export default __exports__